import { useQuery } from '@tanstack/react-query';
import { useApi } from 'contexts/ApiContext';

import useRequiredParams from '@polyai/common/hooks/useRequiredParams';

import type api from 'api';
import type { QueryOptionsFor } from 'hooks/api/types';
import useFeatureSwitch from 'hooks/useFeatureSwitch/useFeatureSwitch';
import { useGetApiConfigMetricsQueryKey } from './hooks';

export interface UseApiConfigMetricsOptions {
  options?: QueryOptionsFor<typeof api.getApiConfigMetrics>;
}

const useApiConfigMetrics = ({ options }: UseApiConfigMetricsOptions = {}) => {
  const { accountId } = useRequiredParams<{
    accountId: string;
  }>();

  const api = useApi();
  const { isFeatureOn } = useFeatureSwitch();

  const queryKey = useGetApiConfigMetricsQueryKey(accountId);

  return useQuery({
    queryKey,
    queryFn: () => api.methods.getApiConfigMetrics(accountId),
    enabled: isFeatureOn('agent_studio_data_access'),
    refetchOnWindowFocus: false,
    retry: false,
    ...options,
  });
};

export default useApiConfigMetrics;
